import axios from 'axios'
import { store } from '../store'
import { hideLoader, showLoader } from '../store/loader/actions'


const instance = axios.create()
instance.interceptors.request.use(
  config => {
    store.dispatch(showLoader())
    config.withCredentials = true
    return config
  },
  error => Promise.reject(error)
)


export const instanceVideoFile = axios.create()
instance.interceptors.request.use(
  config => {
    store.dispatch(showLoader())
    let token = localStorage.getItem('access_token')

   // config.headers = getToken('video/mp4').headers
    // console.log('config: ' + config.headers)
    return config
  },
  err => Promise.reject(err)
)


instance.interceptors.response.use(
  response => {
    store.dispatch(hideLoader())
    return response
  },
  error => {
    store.dispatch(hideLoader())

    const status = error?.response?.status

    if (status === 401) {
      

      window.location.href = `${process.env.REACT_APP_AWS_COGNITO}/logout?response_type=code&client_id=${process.env.REACT_APP_AWS_COGNITO_CLIENTID}&redirect_uri=${process.env.REACT_APP_AWS_COGNITO_REDIRECT_URI}`
    }

    return Promise.reject(error)
  }
)

export default instance

